<div mat-dialog-title>
  <h1>Connect to TypeDB</h1>
  <tp-modal-close-button />
</div>
<div class="tp-modal-content">
  <tp-scroll-container class="tp-modal-body" mat-dialog-content>
    <h2>Setup Driver</h2>
    <p>View the <a class="tp-external-link" [href]="driverDocsLink$ | async" target="_blank">driver documentation<i class="fa-light fa-arrow-up-right"></i></a> for instructions on how to install and set up your driver</p>
    <hr/>
    <h2>Connect to TypeDB</h2>
    @if (ready$ | async) {
      <p>Use the following values to configure your driver</p>
      <tp-properties-table class="dark driver-config">
        @for (address of serverAddresses$ | async; track address) {
          <tp-properties-table-row key="Address" class="tp-copyable tp-address">
            {{ address }}
            <button class="btn-copy" mat-icon-button aria-label="copy" (click)="copy(address!, snackbar); $event.stopPropagation();" matTooltip="Copy to clipboard">
              <i class="fa-light fa-copy"></i>
            </button>
          </tp-properties-table-row>
        }
        <tp-properties-table-row key="Username" class="tp-copyable">
          admin
          <button class="btn-copy" mat-icon-button aria-label="copy" (click)="copy('admin', snackbar); $event.stopPropagation();" matTooltip="Copy to clipboard">
            <i class="fa-light fa-copy"></i>
          </button>
        </tp-properties-table-row>
        <tp-properties-table-row key="Password">
            <{{ PASSWORD_FILLER }}>
        </tp-properties-table-row>
        <tp-properties-table-row key="TLS Enabled">True</tp-properties-table-row>
        <tp-properties-table-row key="Root CA Path">-</tp-properties-table-row>
      </tp-properties-table>
      @if (data.cluster$ | async; as cluster) {
        <p>
          Your database password can be found in your downloaded credentials file if you have one
          (by default: <strong>{{ clusterCredentialFilename(cluster) }}</strong>).
        </p>
      }
    } @else if (loading$ | async) {
      @if (parsedVersion$ | async; as version) {
        <tp-cluster-loading-tips [clusterVersion]="version"/>
      }
    }
  </tp-scroll-container>
</div>
